
// This file is used for SSR prerendering
// It contains the same data as blog-content.ts but in a format that can be imported by Node.js directly
import { content as itManagersHandbook } from './blog-posts/it-managers-handbook.js';
import { content as professionalQaTesting } from './blog-posts/professional-qa-testing.js';
import { content as selfHealingTests } from './blog-posts/self-healing-tests.js';

export const blogContents = {
  'it-managers-handbook-outsourcing-website-development': itManagersHandbook,
  'professional-ai-assisted-qa-testing-service': professionalQaTesting,
  'ai-powered-self-healing-automated-test': selfHealingTests
};
